/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Text as ChromaText } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';
import THEME from 'theme';

interface FontProps {
  lineHeight?: number;
}

const TextWrapper = styled.div`
  p {
    color: ${THEME.TEXT.BODY};
    ${({ lineHeight }: FontProps) =>
      lineHeight &&
      `
     line-height: ${lineHeight}px;
    `}

    a {
      color: ${THEME.TEXT.LINK};
    }
  }
`;

export const Text = ({
  fontSize,
  ...props
}: {
  [key: string]: object | string | number;
}) => (
  <TextWrapper>
    <ChromaText fontSize={16} {...props} />
  </TextWrapper>
);

export default Text;
